import { Route, Routes } from 'react-router-dom';
import ContactSubmissionListPage from './list';

export default function ContactSubmissionRouting() {
  return (
    <Routes>
      <Route index element={<ContactSubmissionListPage />} />
    </Routes>
  );
}
